export default {
  root: {
    class: [
      // Sizing and Shape
      'min-w-[12rem]',
      'rounded-md',
      // Spacing
      'p-1',
      // Colors
      'bg-secondary-0 dark:bg-secondary-700',
      'text-secondary-700 dark:text-white/80',
      'border border-secondary-200 dark:border-secondary-700'
    ]
  },
  menu: {
    class: [
      // Spacings and Shape
      'list-none',
      'm-0',
      'p-0',
      'outline-none'
    ]
  },
  content: ({ context }) => ({
    class: [
      //Shape
      'rounded-none',
      // Colors
      'text-secondary-700 dark:text-white/80',
      {
        'bg-secondary-200 text-secondary-700 dark:bg-secondary-300/10 dark:text-white': context.focused
      },
      // Transitions
      'transition-shadow',
      'duration-200',
      // States
      'hover:text-secondary-700 dark:hover:text-white/80',
      'hover:bg-secondary-100 dark:bg-secondary-700 dark:hover:bg-secondary-400/10'
    ]
  }),
  action: {
    class: [
      'relative',
      // Flexbox

      'flex',
      'items-center',

      // Spacing
      'px-3 py-2',

      // Color
      'text-secondary-700 dark:text-white/80',

      // Misc
      'no-underline',
      'overflow-hidden',
      'cursor-pointer',
      'select-none'
    ]
  },
  icon: {
    class: [
      // Spacing
      'mr-2',

      // Color
      'text-secondary-600 dark:text-white/70'
    ]
  },
  label: {
    class: ['leading-none']
  },
  submenuheader: {
    class: [
      // Font
      'empty:hidden',
      'font-bold',
      // Spacing
      'px-3 py-2',
      // Shape
      'rounded-tl-none',
      'rounded-tr-none',
      // Colors
      'bg-secondary-0 dark:bg-secondary-700',
      'text-secondary-700 dark:text-white'
    ]
  },
  transition: {
    enterFromClass: 'opacity-0 scale-y-[0.8]',
    enterActiveClass: 'transition-[transform,opacity] duration-[120ms] ease-[cubic-bezier(0,0,0.2,1)]',
    leaveActiveClass: 'transition-opacity duration-100 ease-linear',
    leaveToClass: 'opacity-0'
  }
};
